import Alert from '@mui/material/Alert';
import { ReactComponent as AlertSuccessIcon } from 'assets/icons/alert_success.svg';
import { ReactComponent as AlertErrorIcon } from 'assets/icons/alert_error.svg';
import { ReactComponent as AlertInfoIcon } from 'assets/icons/alert_info.svg';
import { ReactComponent as AlertWarningIcon } from 'assets/icons/alert_warning.svg';

const AlertCustom = (props) => {
  return (
    <Alert
      iconMapping={{
        success: <AlertSuccessIcon />,
        error: <AlertErrorIcon />,
        info: <AlertInfoIcon />,
        warning: <AlertWarningIcon />,
      }}
      {...props}
    />
  );
};

export default AlertCustom;
